import { useShallowMemo } from "@firefly/fly-hook";
import { Paths } from "@stage/path";
export function useGridPaths(graphic, target) {
  var viewBox = graphic.viewBox,
    paths = graphic.paths,
    grid = graphic.grid;
  return useShallowMemo(function () {
    return paths.map(function (_ref) {
      var define = _ref.define,
        fill = _ref.fill,
        stroke = _ref.stroke;
      var path = Paths.parse(define);
      var newPath = Paths.expandGrid(path, {
        x: grid.left,
        y: grid.top,
        width: viewBox.width - grid.right - grid.left,
        height: viewBox.height - grid.bottom - grid.top
      }, {
        x: target.width - viewBox.width,
        y: target.height - viewBox.height
      });
      var fillStyle = undefined;
      if (fill) {
        if (typeof fill === 'string') {
          fillStyle = {
            type: "color",
            color: fill
          };
        } else {
          fillStyle = fill;
        }
      }
      return {
        path: newPath,
        fill: fillStyle,
        stroke: stroke
      };
    });
  }, [paths, viewBox.width, viewBox.height, grid, target.width, target.height]);
}